import * as React from "react";
import type { SVGProps } from "react";
const SvgStopwatch01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m19.096 3.513 1.252 1.252M21.6 6.017l-1.252-1.252M8.8 1.287h5.287m4.174 5.565 2.087-2.087M12.6 10.887l-1.8 1.8 1.8 1.8-1.8 1.8m9.965-2.757a9.183 9.183 0 1 1-18.365 0 9.183 9.183 0 0 1 18.365 0"
    />
  </svg>
);
export default SvgStopwatch01;
